// 完了問い合わせ 検索条件
export const COLLECTION_INQUIRY_SEARCH_OBJ = "completed_inquiry_settings";

// 進行中問い合わせ フィルター条件
export const COLLECTION_INQUIRY_FILTER_OBJ = "inprogress_inquiry_settings";

// 計画書自動作成 バッチ処理設定
export const COLLECTION_AI_INDEX = "aiindex-batch-setting";

// アサインメンバー更新設定
export const COLLECTION_ASSIGN_MEMBER_UPDATE = "assign-member-update-setting";
